module.exports = __webpack_public_path__ + "static/process_exporting5_2-c588696de692c627d42d135ad4d956cb.jpg";